import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { Skeleton } from '@/components/ui/skeleton';

const ADMIN_SECRET = import.meta.env.VITE_ADMIN_PATH_SECRET ?? '__ops_dev';

export function RequirePlatformAdmin() {
  const { isAuthenticated, isLoading } = useAdminAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="p-8 space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${ADMIN_SECRET}/login`} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
